var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.0464 24.5L127.695 50.6482L146.343 84.7965L77.0464 97L7.74993 84.7965L26.3982 50.6482L77.0464 24.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.877 87.6428L68.1432 92.8448C68.261 92.865 68.3086 92.6988 68.1979 92.6536L49.4125 84.9848C48.284 84.5241 47.5464 83.4263 47.5464 82.2073V53.2777C47.5464 51.8657 46.8019 50.5583 45.5875 49.8377L38.5567 45.6659C37.8901 45.2704 37.0464 45.7508 37.0464 46.5259V86.6572C37.0464 87.1441 37.3971 87.5603 37.877 87.6428Z",
    fill: "#FF6400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.716 87.6428L85.4496 92.8448C85.3317 92.865 85.2842 92.6988 85.3949 92.6536L104.18 84.9848C105.309 84.5241 106.046 83.4263 106.046 82.2073V53.2777C106.046 51.8657 106.791 50.5583 108.005 49.8377L115.036 45.6659C115.703 45.2704 116.546 45.7508 116.546 46.5259V86.6572C116.546 87.1441 116.196 87.5603 115.716 87.6428Z",
    fill: "#FF6400"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6762 82.4812L69.1205 89.8303C69.2202 89.87 69.304 89.746 69.2298 89.6683L59.8763 79.8695C59.3436 79.3114 59.0464 78.5695 59.0464 77.798V47.864C59.0464 46.5564 58.4072 45.3312 57.3346 44.5832L50.0464 39.5V81.5522C50.0464 81.9616 50.2959 82.3296 50.6762 82.4812Z",
    fill: "#FF9600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.917 82.4812L84.4723 89.8303C84.3726 89.87 84.2888 89.746 84.363 89.6683L93.7165 79.8695C94.2492 79.3114 94.5464 78.5695 94.5464 77.798V47.864C94.5464 46.5564 95.1856 45.3312 96.2582 44.5832L103.546 39.5V81.5522C103.546 81.9616 103.297 82.3296 102.917 82.4812Z",
    fill: "#FF9600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8915 78.2991L68.8809 84.3566C68.9457 84.4127 69.0464 84.3667 69.0464 84.281V75V42.0399C69.0464 40.6359 68.3102 39.3346 67.1068 38.6114L61.5464 35.2698V77.5434C61.5464 77.8334 61.6723 78.1091 61.8915 78.2991Z",
    fill: "#FFCA00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7013 78.2991L84.7119 84.3566C84.6471 84.4127 84.5464 84.3667 84.5464 84.281V75V42.0399C84.5464 40.6359 85.2825 39.3346 86.486 38.6114L92.0464 35.2698V77.5434C92.0464 77.8334 91.9205 78.1091 91.7013 78.2991Z",
    fill: "#FFCA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBax);
export default __webpack_public_path__ + "static/media/logoBax.ff407799169d901643e0292acc31db1a.svg";
export { ForwardRef as ReactComponent };